import React from 'react';
import { CrudStyles } from '../shared/Crud';
import { getDeliveryStatusMeta } from './statusConfig';

const { StatusBadge } = CrudStyles;

/**
 * @param {{ state: string|object, compact?: boolean }} props
 * compact=true omite o min-width fixo, adequado para uso fora de tabelas (ex.: timeline).
 */
export default function DeliveryStatusBadge({ state, compact = false }) {
    const meta = getDeliveryStatusMeta(state);
    const { label, colorToken, icon: Icon } = meta;

    return (
        <StatusBadge
            as="span"
            style={{
                ...(compact ? {} : { minWidth: '11rem' }),
                textTransform: 'none',
            }}
            $active={meta.value === 'DELIVERED'}
            data-color-token={colorToken}
        >
            {Icon ? <Icon /> : null}
            <span>{label}</span>
        </StatusBadge>
    );
}

